import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

@Component({
  selector: 'app-product-select',
  templateUrl: './product-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductSelectComponent),
      multi: true
    }
  ]
})
export class ProductSelectComponent implements OnInit {
  @Input() selected: any;
  product: any = [];
  value: any[] = [];
  searching: boolean = false;
  @Output() readonly selectedChange = new EventEmitter();
  constructor(private http: _HttpClient,) {
  }

  ngOnInit(): void {
    this.getProduct()
  }

  getProduct(){
    this.searching = true;
    this.http.get('api/reporting/partners/getProduct').subscribe({
      next: (res: any) => {
        this.product = res;
        this.searching = false;
      }
    });
  }

  onChange($event: any[]): void{
    this.selected = $event;
    this.selectedChange.emit(this.selected);
  }
}